import { AudioInputSource, DefaultAudioInput } from "@/types/audio";
import { LunaAudioSource } from "@/audio/LunaAudioSource";

interface AudioSourceToggleProps {
  audioSource: AudioInputSource;
  onSourceChange: (source: AudioInputSource) => void;
  disabled?: boolean;
}

export function AudioSourceToggle({
  audioSource,
  onSourceChange,
  disabled = false,
}: AudioSourceToggleProps) {
  const handleSourceChange = (newSource: AudioInputSource) => {
    console.info(
      "🔄 AudioSourceToggle: Switching audio source to:",
      newSource.constructor.name,
    );
    onSourceChange(newSource);
  };

  return (
    <div className="grid w-48 grid-cols-2 bg-gray-900 p-1 rounded-md">
      <button
        onClick={() => handleSourceChange(new DefaultAudioInput())}
        disabled={disabled}
        className={`px-4 py-2 rounded-md transition-colors ${
          audioSource instanceof DefaultAudioInput
            ? "bg-gray-800 text-white"
            : "text-gray-400 hover:text-white"
        } ${disabled && "opacity-50 cursor-not-allowed"}`}
      >
        Browser
      </button>
      <button
        onClick={() => handleSourceChange(new LunaAudioSource())}
        disabled={disabled}
        className={`px-4 py-2 rounded-md transition-colors ${
          audioSource instanceof LunaAudioSource
            ? "bg-gray-800 text-white"
            : "text-gray-400 hover:text-white"
        } ${disabled && "opacity-50 cursor-not-allowed"}`}
      >
        Luna
      </button>
    </div>
  );
}
